import React from 'react';

export default function LayoutDefault({ children }) {
  return <div className="h-full overflow-y-scroll">{children}</div>;
}
